/** Utah's words for objectops-data.ts: altitude, the food truck rule (R392-102), Salt Lake County guideline notes and the Utah food truck fire checklist. */
export const OBJECTOPS_UT = {
  /** Altitude: Utah is high, so a boiling-water thermometer check reads low; use ice water. */
  altitudeNote: "Utah is high, so use ice water.",
  /** The state food truck rule as a source label (R392-102: hose, flush, wastewater and tank-size lines). */
  truckRuleLabel: "Utah mobile food business rule",
  /** Salt Lake County guideline: garden hoses are not food grade. */
  hoseCountyNote: "Garden hoses are not food grade (Salt Lake County).",
  /** Salt Lake County guideline: flush the water system at a minimum of every 30 days. */
  flushCountyNote: "Salt Lake County's guideline: at a minimum of every 30 days.",
  /** Flush interval tail: the state rule and the county guideline in the op's interval line. */
  flushIntervalTail: " (Utah); every 30 days in Salt Lake County",
  /** Salt Lake County: the fee for dumping wastewater down a storm drain. */
  dumpFeeNote: "Salt Lake County: dumping down a storm drain brings a fee of $1,000.00 to $2,000.00 for each reoccurring violation.",
  /** Salt Lake County: the waste tank size example (30 gallon fresh tank needs a 34.5 gallon waste tank). */
  wasteTankCountyNote: "Salt Lake County: a 30 gallon fresh tank needs a 34.5 gallon waste tank.",
  /** The state food truck fire checklist as a source label (no fueling with the public near, LPG outside, gas leak line). */
  truckFireChecklist: "Utah food truck fire checklist",
  /** City name in the grease trap interval line (Salt Lake City: indoor traps weekly). */
  trapCity: "Salt Lake City",
  /** The city utility that hosts the restaurant association's grease guide (and takes used oil), in the grease trap guide. */
  trapUtility: "Salt Lake City Public Utilities",
} as const;
